import React, { createContext, useContext, useEffect, useState } from 'react';
import { useLocation, useNavigate } from 'react-router-dom';

const GlobalContext = createContext();

export const GlobalProvider = ({ children }) => {
    const location = useLocation();
    const navigate = useNavigate();
    const [user, setUser] = useState(null);



    function checkurl() {
        const params = new URL(window.location.href).searchParams;
        const phone = params.get("Phonenumber");
        const IDProvider = params.get("IDPaymentProvider");
        

        if (phone && IDProvider) {
            console.log(phone)
            fetch(`https://apiv2.mobileartsme.com/LoginWithoutPass?IDService=1&MSISDN=${phone}&IDProvider=${IDProvider}`)
                .then(response => response.json())
                .then(data => {
                    if (data.Error === 0) {
                        if (data.Result.Description === "Subscription Active") {

                            const userData = {
                                ...data.Result,
                                phone: phone
                            };
                            localStorage.setItem('AV_User_Data', JSON.stringify(userData));
                            window.location.href = "/home";
                        }
                    }
                })
        } else {
            console.log('no phone')
        }

    }




    useEffect(() => {
        checkurl()
        const storedUser = JSON.parse(localStorage.getItem("AV_User_Data"));
        setUser(storedUser);

        if (!storedUser) {
            if (location.pathname == '/Contact') {
                navigate('/Contact');
            }
            else if (location.pathname == '/subscribe') {
                navigate('/subscribe');

            } else {
                navigate('/')

            }
        }

        if (storedUser && location.pathname === '/') {
            navigate('/home'); // Redirect to home if already authenticated
        }
    }, [location.pathname]);

    return (
        <GlobalContext.Provider value={{ user, setUser }}>
            {children}
        </GlobalContext.Provider>
    );
};

// Custom hook to use the global context
export const useGlobalContext = () => useContext(GlobalContext);
